import { HistoryAction } from "./historyManager";
import $ from "jquery";

export interface ColorElementAction extends HistoryAction {
    type: "color_elem";
    target: "selectedItem" | "selectedItem-border" | "page" | "trace" | "elevation-bg" | "elevation-bordure" | "marker-element-contour";
    itemId?: any;
    fromColor: string;
    toColor: string;
}

export function createColorElementAction(
    params: {
        target: ColorElementAction["target"];
        itemId?: any;
        fromColor: string;
        toColor: string;
        context: any;
    }
): ColorElementAction {

    const { target, itemId, fromColor, toColor, context } = params;

    function applyColor(color: string) {
        const {
            objItems,
            selectedItem,
            setPageColor,
            elevationData,
            setElevationData,
            chartRef
        } = context;

        if (target === 'selectedItem') {
            /* To set changed property to listItems*/
            const item = objItems.find((i: any) => i.id === itemId);
            if (!item) return;

            if (item.type === "shape-element") $("#"+itemId + " > div ").css("background-color", color);
            else $("#"+itemId).css("color", color)
            item.style.color = color;

        }
        if (target === 'selectedItem-border') {
            /* To set changed property to listItems*/
            const item = objItems.find((i: any) => i.id === itemId);

            if (selectedItem != null) {
                if (item.type === "shape-element") $("#"+itemId + " > div ").css("border-color", color);
                item.style["border-color"] = color;
            }
        }
        if (target === 'page')
            if (setPageColor != null) setPageColor(color);
        if (target === "elevation-bg") {

            let copyJson = { ...elevationData };
            copyJson.datasets[0].backgroundColor = color;

            if (chartRef.current != null) {
                chartRef.current.ctx.fillStyle = color;

                chartRef.current.data.datasets[0].backgroundColor = color;

                if (setElevationData != null) setElevationData(copyJson);
                chartRef.current.update('none');
            }
        }
        if (target === "elevation-bordure") {

            let copyJson = { ...elevationData };
            copyJson.datasets[0].borderColor = color;

            if (chartRef.current != null) {

                chartRef.current.data.datasets[0].borderColor = color;

                chartRef.current.update('none');
            }
            if (setElevationData != null) setElevationData(copyJson);
        }
        if (target === "marker-element-contour") {

            var itemMakerLabel = context.marker.markerTxt.getElement();
            context.marker.markerTxtStyle['-webkit-text-stroke-color'] = color;
            itemMakerLabel.style['-webkit-text-stroke-color'] = color;
        }

        

    }

    return {
        type: "color_elem",
        target,
        itemId,
        fromColor,
        toColor,

        undo() {
            applyColor(fromColor);
        },

        redo() {
            applyColor(toColor);
        }
    };
}